import {SnackbarCloseReason} from '@mui/base';
import {AlertColor} from '@mui/material/Alert';

export interface PublicToastNotificationSnackBarContextState {
  open: boolean;
  autoHideDuration: number;
  title?: string;
  message?: string;
  severity?: AlertColor;
}

export interface OfficeToastNotificationSnackBarContextState {
  open: boolean;
  autoHideDuration: number;
  title?: string;
  message?: string;
  severity?: AlertColor;
  buttonLabel?: string;
}

export interface DailyCareLogToastNotificationSnackBarContextState {
  open: boolean;
  autoHideDuration: number;
  title?: string;
  message?: string;
  severity?: AlertColor;
  buttonLabel?: string;
}

export interface SnackBarContextState {
  publicToastNotification: PublicToastNotificationSnackBarContextState;
  officeToastNotification: OfficeToastNotificationSnackBarContextState;
  dailyCareLogToastNotification: DailyCareLogToastNotificationSnackBarContextState;
}

export enum SnackBarContextActionType {
  SET_PUBLIC_TOAST_NOTIFICATION = 'SET_PUBLIC_TOAST_NOTIFICATION',
  RESET_PUBLIC_TOAST_NOTIFICATION = 'RESET_PUBLIC_TOAST_NOTIFICATION',
  SET_OFFICE_TOAST_NOTIFICATION = 'SET_OFFICE_TOAST_NOTIFICATION',
  RESET_OFFICE_TOAST_NOTIFICATION = 'RESET_OFFICE_TOAST_NOTIFICATION',
  SET_DAILY_CARE_LOG_TOAST_NOTIFICATION = 'SET_DAILY_CARE_LOG_TOAST_NOTIFICATION',
  RESET_DAILY_CARE_LOG_TOAST_NOTIFICATION = 'RESET_DAILY_CARE_LOG_TOAST_NOTIFICATION',
}

export type SnackBarContextAction =
  | {
      type: SnackBarContextActionType.SET_PUBLIC_TOAST_NOTIFICATION;
      toastNotification: PublicToastNotificationSnackBarContextState;
    }
  | {
      type: SnackBarContextActionType.RESET_PUBLIC_TOAST_NOTIFICATION;
      toastNotification: PublicToastNotificationSnackBarContextState;
    }
  | {
      type: SnackBarContextActionType.SET_OFFICE_TOAST_NOTIFICATION;
      toastNotification: OfficeToastNotificationSnackBarContextState;
    }
  | {
      type: SnackBarContextActionType.RESET_OFFICE_TOAST_NOTIFICATION;
      toastNotification: OfficeToastNotificationSnackBarContextState;
    }
  | {
      type: SnackBarContextActionType.SET_DAILY_CARE_LOG_TOAST_NOTIFICATION;
      toastNotification: DailyCareLogToastNotificationSnackBarContextState;
    }
  | {
      type: SnackBarContextActionType.RESET_DAILY_CARE_LOG_TOAST_NOTIFICATION;
      toastNotification: DailyCareLogToastNotificationSnackBarContextState;
    };

export interface SetPublicToastNotification {
  severity: AlertColor;
  message: string;
  title?: string;
}

export interface SetOfficeToastNotification {
  severity: AlertColor;
  message: string;
  title?: string;
}

export interface SetDailyCareLogToastNotification {
  severity: AlertColor;
  message: string;
  title?: string;
}

export interface SnackBarContextType {
  state: SnackBarContextState;

  // Methods
  setPublicToastNotification: (toastNotification: SetPublicToastNotification) => Promise<void>;
  setOfficeToastNotification: (toastNotification: SetOfficeToastNotification) => Promise<void>;
  setDailyCareLogToastNotification: (
    toastNotification: SetDailyCareLogToastNotification
  ) => Promise<void>;
  resetPublicToastNotification:
    | ((
        event: React.SyntheticEvent<Element, Event> | undefined,
        reason?: SnackbarCloseReason
      ) => void)
    | undefined
    | any;
  resetOfficeToastNotification:
    | ((
        event?: React.SyntheticEvent<Element, Event> | undefined,
        reason?: SnackbarCloseReason
      ) => void)
    | undefined
    | any;
  resetDailyCareLogToastNotification:
    | ((
        event?: React.SyntheticEvent<Element, Event> | undefined,
        reason?: SnackbarCloseReason
      ) => void)
    | undefined
    | any;
}
